import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { BRAND } from "../data/content";

export default function WhatsAppFab() {
  const whatsappNumber = (BRAND.whatsapp || "").replace(/\D/g, "");
  const href = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    "Hi Enndo Web Solution! I’d love to discuss a website / project with you."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      style={{
        position: "fixed",
        right: 22,
        bottom: 22,
        width: 58,
        height: 58,
        borderRadius: "50%",
        background: "#25D366",
        color: "#fff",
        display: "grid",
        placeItems: "center",
        zIndex: 90,
        boxShadow: "0 14px 30px -8px rgba(37,211,102,0.6), 0 0 0 0 rgba(37,211,102,0.5)",
        animation: "pulseGlow 2.4s ease-out infinite",
        transition: "transform 0.2s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <FaWhatsapp size={28} />
    </a>
  );
}
